import {
  compose,
  lifecycle,
  withHandlers,
  withState,
  defaultProps,
} from 'recompose';
import { connect } from 'react-redux';

import { getUserPunchCards } from 'actions/loyalties';
import { hideIfNoData } from 'utils/enhancers';

import StampCards from './StampCards';

const PAGING_LIMIT = 20;

const mapDispatchToProps = {
  onInit: getUserPunchCards,
};

const state = compose(
  withState('initialData', 'setInitialData'),
  withState('sortName', 'setSortName', 'id'),
  withState('sortDirection', 'setSortDirection', 'asc'),
  withState('page', 'setPage', 0),
  defaultProps({
    pageLimit: PAGING_LIMIT,
  })
);

const refresh = (props) => {
  const {
    userId,
    sortName,
    sortDirection,
    page,
    pageLimit,
    onInit,
    setInitialData,
  } = props;
  return onInit({
    userId,
    sortName,
    sortDirection,
    page,
    pageLimit,
  }).then(setInitialData);
};

const handlers = withHandlers({
  onInit: (props) => () => refresh(props),
  onSort: (props) => ({ sortName, sortDirection }) => {
    props.setPage(0);
    props.setSortName(sortName);
    props.setSortDirection(sortDirection);
    return refresh({ ...props, sortName, sortDirection, page: 0 });
  },
  onPage: (props) => ({ page }) => {
    props.setPage(page);
    return refresh({ ...props, page });
  },
});

const retrieveData = lifecycle({
  componentDidMount() {
    this.props.onInit();
  },
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
  state,
  handlers,
  retrieveData,
  hideIfNoData((props) => !props.initialData)
)(StampCards);
